import { render } from "./CardOfertaComponent.vue?vue&type=template&id=2e062f90&scoped=true"
import script from "./CardOfertaComponent.vue?vue&type=script&lang=js"
export * from "./CardOfertaComponent.vue?vue&type=script&lang=js"

import "./CardOfertaComponent.vue?vue&type=style&index=0&id=2e062f90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e062f90"]])

export default __exports__